export interface IAuthenticationState {
  readonly cognitoUser?: undefined;
  readonly isAuthenticated?: boolean;
  readonly isForgottenPassword?: boolean;
  readonly redirectLocation?: string;
  readonly organisationId?: string;
  readonly loginAttempts?: number;
  readonly hasLoaded?: boolean;
  readonly hasSaved?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly user?: {
    readonly id?: string;
    readonly email?: string;
    readonly password?: string;
  };
}

export type IAuthenticationSelector = IAuthenticationState;

export enum AuthenticationActionTypes {
  AUTHENTICATE_COGNITO_USER_REQUESTED = 'redux-app/authentication/AUTHENTICATE_COGNITO_USER_REQUESTED',
  AUTHENTICATE_COGNITO_USER_PENDING = 'redux-app/authentication/AUTHENTICATE_COGNITO_USER_PENDING',
  AUTHENTICATE_COGNITO_USER_SUCCESS = 'redux-app/authentication/AUTHENTICATE_COGNITO_USER_SUCCESS',
  AUTHENTICATE_COGNITO_USER_FAIL = 'redux-app/authentication/AUTHENTICATE_COGNITO_USER_FAIL',
  REFRESH_COGNITO_USER_REQUESTED = 'redux-app/authentication/REFRESH_COGNITO_USER_REQUESTED',
  REFRESH_COGNITO_USER_SUCCESS = 'redux-app/authentication/REFRESH_COGNITO_USER_SUCCESS',
  FORGOT_PASSWORD_REQUESTED = 'redux-app/authentication/FORGOT_PASSWORD_REQUESTED',
  FORGOT_PASSWORD_PENDING = 'redux-app/authentication/FORGOT_PASSWORD_PENDING',
  FORGOT_PASSWORD_SUCCESS = 'redux-app/authentication/FORGOT_PASSWORD_SUCCESS',
  FORGOT_PASSWORD_FAIL = 'redux-app/authentication/FORGOT_PASSWORD_FAIL',
  CHANGE_PASSWORD_REQUESTED = 'redux-app/authentication/CHANGE_PASSWORD_REQUESTED',
  CHANGE_PASSWORD_PENDING = 'redux-app/authentication/CHANGE_PASSWORD_PENDING',
  CHANGE_PASSWORD_SUCCESS = 'redux-app/authentication/CHANGE_PASSWORD_SUCCESS',
  CHANGE_PASSWORD_FAIL = 'redux-app/authentication/CHANGE_PASSWORD_FAIL',
  USER_LOGOUT_REQUESTED = 'redux-app/authentication/USER_LOGOUT_REQUESTED',
  USER_LOGOUT = 'redux-app/authentication/USER_LOGOUT',
  REFRESH_OR_LOGOUT_REQUESTED = 'redux-app/authentication/REFRESH_OR_LOGOUT_REQUESTED',
  RESET_AUTHENTICATE_ERRORS = 'redux-app/authentication/RESET_AUTHENTICATE_ERRORS',
  SWITCH_ORGANISATION = 'redux-app/authentication/SWITCH_ORGANISATION',
}

export default null;
